import React from "react";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useGetListings } from "hooks/useGetListings";

export interface ListingsPageHeaderProps {
  heading?: ReactNode;
  subHeading?: ReactNode;
  className?: string;
}

const ListingsPageHeader: React.FC<ListingsPageHeaderProps> = ({
  className = "",
  subHeading,
}) => {
  const {listingsLoading,totalListingFound} = useGetListings();

  const { t } = useTranslation()



  return (
    <div className={`mb-12 lg:mb-16 ${className}`}>
      <h2 className="text-4xl font-semibold">{t("Stays")}</h2>
      {subHeading ? (
        subHeading
      ) : listingsLoading ?
        (
          <span className="block text-neutral-500 dark:text-neutral-400 mt-3">
            {t("loading...")}
          </span>
        )
        :
        (
          <span className="block text-neutral-500 dark:text-neutral-400 mt-3">
            {totalListingFound} {t("properties available")}
          </span>
        )}
    </div>
  );
};

export default ListingsPageHeader;
